// 通用【首页】菜单请求头
export const AXIOS = {
  axios: {
    headers: {
      'X-menu-id': '2820215716730110'
    }
  }
}



// WEBPACK FOOTER //
// ./src/public/utils/common-api.js